import { computed, watch, WatchStopHandle } from 'vue';
import { CampaignType } from '@studyportals/campaign-management-api-interface';
import { IPresentableEntity } from '@/models/available-entities.interface';
import { ModalErrorStates } from '@/models/modal/modal.enum';
import campaignPresenter from '@/presenters/campaign-presenter';
import store from '@/store';

export default class LinkedOrganisationsCode {
	private unwatch: WatchStopHandle | null = null;

	public isCampaignTypeCustomProducts = computed((): boolean => {
		return this.campaignType.value === CampaignType.CUSTOM_PRODUCTS;
	});

	public availableEntities = computed((): IPresentableEntity[] => {
		return store.getters.availableEntities();
	});

	private campaignType = computed((): CampaignType | null => {
		return store.getters.campaignType();
	});

	public async mounted(): Promise<void> {
		await this.loadEssentialData();
		store.mutations.incrementLoadCount();
		this.unwatch = watch(this.campaignType, this.ifCampaignIsCustomProductsOnlyTriggerError.bind(this));
	}

	public unmounted(): void {
		if (!this.unwatch) {
			return;
		}

		this.unwatch();
	}

	private ifCampaignIsCustomProductsOnlyTriggerError(): void {
		if (!this.isCampaignTypeCustomProducts.value) {
			return;
		}

		store.mutations.setModalErrorState(ModalErrorStates.CUSTOM_PRODUCTS_ONLY_CAMPAIGN_PAGE_VIEW);
	}

	private async loadEssentialData(): Promise<void> {
		if (this.availableEntities.value.length) {
			return;
		}

		// Listing entities data is needed so that, if an organisation is unlinked, we know whether any entities will be detached.
		await campaignPresenter.retrieveCampaignListingEntities();
		campaignPresenter.updateOriginalCampaignData();
	}
}
